"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorStyles = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var styled_components_1 = require("styled-components");

var hasErrors = ui_blocks_1.FORM.hasErrors;
var defaultStyles = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  background: ", ";\n  ", "\n"], ["\n  ", "\n  background: ", ";\n  ", "\n"])), hasErrors, function (_a) {
  var theme = _a.theme;
  return (0, ui_helper_deep_branding_1.getFromTheme)('COLOR.RED["100"]', theme);
}, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', inverseStyles);
});
var inverseStyles = (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  background: transparent;\n"], ["\n  background: transparent;\n"])));
exports.errorStyles = (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n"])), defaultStyles, function (props) {
  return (0, ui_helper_props_to_styles_1.switchStyles)(props, 'isInverse', inverseStyles);
});
var templateObject_1, templateObject_2, templateObject_3;